import React, { FunctionComponent } from "react"
import PositiveResponseCrudService from "../utils/PositiveResponseCrudService"
import PositiveResponseService from "../utils/PositiveResponseService"
import "./PositiveResponsesNoBadTickets.css"

const PositiveResponsesNoBadTickets: FunctionComponent<{}> = () => {

    const { getBadTicketPositiveResponses } = PositiveResponseCrudService
    const { refresh } = PositiveResponseService

    const refetch = () => {
        refresh()
        getBadTicketPositiveResponses()
    }

    return (
        <div className="PositiveResponsesNoBadTickets">
            <div className="PositiveResponsesNoBadTicketsUpper">
                <span className="material-icons">done</span>
            </div>
            <div className="PositiveResponsesNoBadTicketsLower">
                <p>No bad tickets</p>
            </div>
            <div className="PositiveResponsesNoBadTicketsRefresh" onClick={() => refetch()}>
                <span className="material-icons">refresh</span>
            </div>
        </div>
    )
}

export default PositiveResponsesNoBadTickets